import { IMissionPlanProfilSci } from "../missionPlan/IMissionPlanProfilSci"
import { IMissionSensor } from "../missionPlan/IMissionSensor"


export interface IGliderFleetFormationConfig {	 
	libelle:string|null
	glider_type:string	
	battery_type:string		
	bms_type:string
	payload:Array<{id:number,snr_label:string}>
	prf_sci:Array<IMissionPlanProfilSci>
	start_energy:number
	end_battery_percent:number
}

export function getDefaultGliderFleetFormationConfig({libelle=null as string|null,glider_type="SEAEXPLORER",battery_type="pack 18650",bms_type="neogy",payload=[] as Array<{id:number,snr_label:string}>,start_energy=29,end_battery_percent=15,prf_sci=[] as Array<IMissionPlanProfilSci>}={}) {
	return {		
		libelle,
		glider_type,		
		battery_type,
		bms_type,
		payload,
		start_energy,
		end_battery_percent,
		prf_sci
	} as IGliderFleetFormationConfig
}